export const MIN_WALLET_NAME_LENGTH = 2
export const MAX_WALLET_NAME_LENGTH = 15
export const WALLET_NAME_REGEXP = /^[a-zA-Z0-9 ]+$/
export const WALLET_MIN_AMOUNT = 0.1